import * as React from 'react';

/**
 * This is not tested! Use at your own risk.
 */
export function useDebounce<T>(value: T, timeout: number): T {
  const [debouncedValue, setDebouncedValue] = React.useState(value);

  React.useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), timeout);
    return () => clearTimeout(handler);
  }, [value, timeout]);

  return debouncedValue;
}
